import { css, jsx } from '@emotion/core';
import React, { useEffect, useState } from 'react';

import AmicusSearch from '@/src/amicus/components/AmicusSearch';
import Blocks from '@/src/cms/components/CMSPage/CorePage/Blocks';
import HeroContent from '@/src/cms/components/CMSPage/CorePage/HeroContent';
import DesignPage from '@/src/cms/models/DesignPage';
import AdminLink from '@/src/shared/components/AdminLink';
import Container from '@/src/shared/components/Container';
import Layout from '@/src/shared/components/Layout';
import withMembershipAccessWrap from '@/src/shared/components/MembershipPageWrap';
import Section from '@/src/shared/components/Section';
import WebLogImage from '@/src/shared/components/WebLogImage';
import { ADVOCACY_ACCESS } from '@/src/shared/constants';
import request from '@/utils/axios';

const style = {
  searchContainer: css`
    @media print {
      padding-bottom: 0px !important;
      padding-top: 0px !important;
    }
  `,
};

const Amicus = ({ messageData = {} }) => {
  const [pagedata, setPageData] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchDesignPage = async () => {
    const response = await request({
      url: `cms/designpage`,
      params: {
        alias: 'amicus',
      },
    });
    const { data } = response;
    setPageData(data);
    setLoading(false);
  };

  useEffect(() => {
    fetchDesignPage();
  }, []);

  if (loading) {
    return null;
  }

  const designPageData = new DesignPage({ ...pagedata, ...messageData });

  return (
    <Layout>
      <AdminLink pageID="511" pageType="core" />
      <HeroContent
        heroData={{
          ...designPageData,
        }}
      />

      {designPageData.Blocks.map(b => (
        <Blocks
          key={b}
          blockData={designPageData.entities.Blocks[b]}
          entities={designPageData.entities}
        />
      ))}
      <Section css={style.searchContainer}>
        <Container>
          <AmicusSearch />
        </Container>
      </Section>
      <WebLogImage browserPath pagedata={pagedata} />
    </Layout>
  );
};

export default withMembershipAccessWrap(Amicus, ADVOCACY_ACCESS.LEGAL_AMICUS);
